import { render, staticRenderFns } from "./StatusSwitcher.vue?vue&type=template&id=4e965804&scoped=true&"
import script from "./StatusSwitcher.vue?vue&type=script&lang=js&"
export * from "./StatusSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./StatusSwitcher.vue?vue&type=style&index=0&id=4e965804&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e965804",
  null
  
)

export default component.exports